import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { translate } from 'react-translate';
//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Modal
} from 'semantic-ui-react';
import Exit from '../../../assets/svg/Exit.svg';
import './renameList.css';


import { addList } from '../../../redux/actions/ListAction'
import renommer from '../../../assets/svg/renommer.svg';

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app
})

const mapActionToProps = {
    addList: addList
}

class ConnectedRenameList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fkuidlist: this.props.app.pkuidlist,
            name: this.props.nameList,
            modalOpenRename: false
        }

        this.handleSubmitUpdate = this.handleSubmitUpdate.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);

        this.handleOpenRename = this.handleOpenRename.bind(this);
        this.handleCloseRename = this.handleCloseRename.bind(this);
        this.handleCloseRenameSecond = this.handleCloseRenameSecond.bind(this);
        this.addList = this.addList.bind(this);
    }

    addList(list) {
        this.props.addList(list)
    }


    handleOpenRename() {
        this.setState({
            modalOpenRename: true,
        })
    }

    handleCloseRename() {

        var self = this;
        var listData = {
            fkuiduser : this.props.app.id
        };

        API.getList(this.props.app.token, listData).then((res) => {
            var response = res.data;
            self.addList(response.lists);
        });

        this.setState({
            modalOpenRename: false,
        })

    }

    handleCloseRenameSecond() {
        this.setState({
            modalOpenRename: false
        })
    }

    handleSubmitUpdate(event) {
        var name;
        var self = this;
        event.preventDefault();
        if (this.state.name === null || this.state.name === '') {
            name = 'sans nom';
        } else {
            name = this.state.name;
        }
        var listData = {
            fkuiduser : this.props.app.id,
            name: name,
            pkuidlist: this.props.fkuidlist
        }

        API.updateList(this.props.app.token, listData).then((res) => {
            var response = res.data;
            this.setState({
                response: response
            });
            this.handleCloseRename();
        });

    }

    handleChangeName(event) {
        this.setState({
            name: event.target.value
        });
    }

    render() {
        const { t } = this.props
        return (
            <div>


                <Modal open={this.state.modalOpenRename}
                    onClose={this.handleCloseRenameSecond} size='tiny' trigger={
                        <Image onClick={this.handleOpenRename} src={renommer} />
                    } >
                    <Modal.Header id="modalHeader">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column textAlign='center'>
                                    <Image
                                      id="modalExit"
                                      src={Exit}
                                      onClick={this.handleCloseRenameSecond}
                                      floated='right' />
                                    <Header
                                      id="modalTitle"
                                      textAlign='center'>
                                      {t("title1")}
                                    </Header>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Header>
                    <Modal.Content>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column id="modalContentText">
                                    {t("title1")}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <Input
                                        fluid
                                        size='huge'
                                        onChange={this.handleChangeName}
                                        id="renameList"
                                        value={this.state.name}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={2}>
                                <Grid.Column width={8}>
                                    <Button
                                      id="cancelBtn"
                                      size='massive'
                                      fluid
                                      onClick={this.handleCloseRenameSecond}>
                                      {t("title3")}
                                    </Button>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Button
                                      id="validBtn"
                                      size='massive'
                                      fluid
                                      onClick={this.handleSubmitUpdate}>
                                      {t("title4")}
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}
const RenameList = connect(mapStateToProps, mapActionToProps)(ConnectedRenameList);
export default translate("RenameList")(RenameList);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/RenameList.js